// @flow

import styles from './MetaLinkRenderer.less';

import React from 'react';
import NavLink from 'src/components/NavLink/NavLink';

import { connect } from 'react-redux';

import {
  jobClassificationClicked,
  jobSubclassificationClicked,
  jobLocationClicked,
  jobAreaClicked,
  jobSuburbClicked,
  jobCompanyClicked
} from 'src/store/search/search';

type Props = {
  item: {
    params: SearchParams,
    title: string,
    name: string
  },
  type: string
};

const mapDispatchToProps = {
  location: jobLocationClicked,
  classification: jobClassificationClicked,
  subClassification: jobSubclassificationClicked,
  area: jobAreaClicked,
  suburb: jobSuburbClicked,
  company: jobCompanyClicked
};

export default connect(
  null,
  mapDispatchToProps
)((props: Props) => (
  <NavLink
    className={styles.root}
    location={{
      pathname: '/jobs',
      query: props.item.params
    }}
    onClick={props[props.type]}
    title={props.item.title}
    aria-label={props.item.title}
    data-automation={`job${props.type
      .charAt(0)
      .toUpperCase()}${props.type.substr(1)}`}
  >
    {props.item.name}
  </NavLink>
));
